// removed by extract-text-webpack-plugin
module.exports = {"FileInputButton":"FileInputButton__3eJGc","FileName":"FileName__1TCF3","FileInput":"FileInput__3czDy","ChatFooterUploadButton":"ChatFooterUploadButton__9t6tj"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Chat/ChatFooter/ChatFooterUploadButton.scss
// module id = 2/Ia
// module chunks = 0